import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import * as Validations from "../../../common/form/validator";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "primereact/button";
import { TabMenu } from "primereact/tabmenu";
import { Form, Field } from "react-final-form";
import { Editor } from "@tinymce/tinymce-react";
import { createPortal } from "react-dom";
import CustomBreadCrumbs from "../../../common/breadcrumbs";
import Section from "../../../common/section";
import { DropdownInput, DatePicker } from "../../../common/fields";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import UserList from "./UserList";
import { PICKER_BASE_QUERY, useUserPicker } from "./useUserPicker";
import { DropdownInputUF } from "../../../common/fields";
import { TextInputNoti } from "../../../common/fields";
import { useIntl } from "react-intl";
import intl from "../../../../i18n/intl";
import { connect } from "react-redux";
import {
  defaultTimezone,
  fromExecutionDate,
  toExecutionDate,
} from "../../../../helpers/NotificationSchedule";
import { toast } from "react-toastify";
import { setQuery as audSetQuery } from "../../../../store/slices/audienceSlice";
import {
  GetNotificationClone,
  updateNotiBasicInfo,
  GetOthersCategoryRequest,
  updateCustomNotiRecipant,
  updateNotificationContentRequest,
  GetContentRequest,
} from "../../../../store/slices/notificationSlice";
import { getRolesRequest } from "../../../../store/slices/rolesSlice";
import { listRequest } from "../../../../store/slices/usersSlice";
import { useSelector, useDispatch } from "react-redux";
import RoleList from "./RoleList";
import CohortList from "./CohortList";
import {
  joinAudience,
  splitAudience,
  useAudienceKinds,
} from "./audienceRecipients";
import { toRecipients } from "./useRecipientSelection";
import { isAiWriteAvailable, runAiWrite } from "./aiWrite";
import { listRequest as audienceListRequest } from "../../../../store/slices/audienceSlice";
import { LANGUAGES } from "../../../../constants/GlobalConstants";
import { integrationSubtypesRequest } from "../../../../store/slices/integrationSlice";
import { Message } from "primereact/message";

const customIntl = intl();

// Stable stand-ins while a list has not loaded: a new [] on every render
// would make every effect that depends on the list run on every render.
const NO_ROWS = [];
// Same idea for a single object (see NotificationForm.js's NO_CATEGORY): a
// new {} on every render makes useSelector's default === check see a
// "changed" value on every render, forcing a needless re-render of this
// screen on every store update, not only ones that touch notiStatus.
const NO_STATUS = {};

const CustomNotificationForm = ({
  updateNotiBasicInfo,
  GetNotificationClone,
  GetOthersCategoryRequest,
  newUpadtedNotificationContent,
  updateCustomNotiRecipant,
  updateNotificationContentRequest,
  integrationSubtypesRequest,
  content,
  GetContentRequest,
  audienceListRequest,
  categoryData,
  listRequest,
  response,
  integrations = {},
  getRolesRequest,
  updatedRecipant,
  initial = {},
}) => {
  const navigate = useNavigate();
  const intl = useIntl();
  const location = useLocation();
  const id = location.state?.id;
  const [activeTab, setActiveTab] = useState(0);
  const [notificationName, setNotificationName] = useState("");
  const [categoryName, setCategoryName] = useState("others");
  const [urgencyFlag, setUrgencyFlag] = useState(0);
  const [startDate, setStartDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [placeholders, setPlaceholders] = useState([]);
  // M1 (phase2-P-UI-2-review): the admin's own browser zone, not a fixed
  // "Asia/Calcutta". Overwritten by the loaded notification's own zone once
  // it answers (GetSuccess effect below); this is only what shows before
  // that, and the clone/add builder's own default (NotificationForm.js).
  const [timezone, setTimezone] = useState(defaultTimezone());
  const [showSuggestions, setShowSuggestions] = useState(false);
  const dropdownRef = useRef(null);
 const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0, width: 200});
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const [isEditable, setIsEditable] = useState(false);
  const [templates, setTemplates] = useState(initial.templates || []);
  const [selectedLanguage, setSelectedLanguage] = useState("en");
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState(initial.body || "");
  const editorRef = useRef(null);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [languages, setLanguages] = useState([]);
  //   const [showUsersDialog, setShowUsersDialog] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  //   const [showRolesDialog, setShowRolesDialog] = useState(false);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [currentNotificationName, setCurrentNotificationName] = useState("");
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [basicInfoPrev, setBasicInfoPrev] = useState({});
  const [recipantsPrev, setRecipantsPrev] = useState({
    userTo: [],
    roles: [],
    cohorts: [],
    other: [],
  });
  const [contentPrev, setContentPrev] = useState([
    {
      languageKey: "en",
      subject: "",
      body: "",
    },
  ]);

  const channelList = [
    { key: "email", label: "Email" },
    { key: "NotificationWidgets", label: "Notification Widget" },
    { key: "sms", label: "SMS", comingSoon: true },
    { key: "teams", label: "MS Teams", comingSoon: true },
    { key: "whatsapp", label: "WhatsApp", comingSoon: true },
    { key: "messenger", label: "Messenger", comingSoon: true },
  ];

  const dispatch = useDispatch();

  // Channels
  const [channels, setChannels] = useState(() => ({
    email: true,
    notification: true,
    sms: false,
    teams: false,
  }));

  const formStateRef = useRef(null);
  const inputWrapperRef = useRef(null);
  const itemRefs = useRef([]);

  // placehoders for lists/options used in dropdowns
  const urgencyOptions = [
    { name: "Normal", value: 0 },
    { name: "High Priority", value: 1 },
  ];

  // calendar key placeholder
  const calendarKey = "cal-1";

  const notiStatus = useSelector(
    (state) => state.notifications.notiStatus || NO_STATUS
  );
  const requesting = useSelector((state) => state.notifications.requesting);

  const selectSuggestion = (sugg) => {
    const newValue = subject.replace(/\{[^{}]*$/, `{{${sugg}}}`);
    setSubject(newValue);
    setShowSuggestions(false);
  };

  const handleSubjectChange = (e, formProps) => {
    // console.log(e, "e val---->>>");
    const value = e;
    setSubject(value);
    formProps.form.change("subject", value);
    // Show suggestions when user types "{"

    const splitedArr = value.trim().split(" ").reverse();

    for (let i = 0; i < splitedArr.length; i++) {
      const regEx = /^\{[a-zA-Z]*$/;
      if (regEx.test(splitedArr[i]) && splitedArr[i] != " ") {
        setFilteredSuggestions(placeholders);
        setShowSuggestions(true);
        i = splitedArr.length;
      } else {
        setShowSuggestions(false);
      }
    }

    if (showSuggestions) {
      const match = value.split("{").pop().toLowerCase();
      const filtered = placeholders.filter((p) =>
        p.toLowerCase().includes(match)
      );
      setFilteredSuggestions(filtered);
      if (filtered.length === 0) setShowSuggestions(false);
    }
  };

  const handleLanguageChange = (e, formProps) => {
    const langCode = e;

    setSelectedLanguage(langCode);
    setSubject("");
    setBody("");
    formProps.form.change("subject", "");

    // if (isEdit == false) {
    //   if (isClone == true) {
    //     formProps.form.change("subject", subject);
    //   }
    //   if (subject != "" && body != "") {
    //     let editorContentData = editorRef.current.getContent();
    //     if (
    //       formProps.values.language != "" &&
    //       formProps.values.subject != "" &&
    //       editorContentData != ""
    //     ) {
    //       const editorContent = editorRef.current ? editorContentData : body;
    //       const timestamp = new Date().toISOString(); // e.g., "2025-10-08T08:27:07.370Z"
    //       const foundTemplate =
    //         templates.length > 0
    //           ? templates.find(
    //               (t) => t.languageKey == formProps.values.language
    //             )
    //           : {};
    //       if (foundTemplate) {
    //         setTemplates(
    //           templates.filter(
    //             (t) => t.languageKey !== foundTemplate.languageKey
    //           )
    //         );
    //       }

    //       // Create object
    //       const templateObject = {
    //         languageKey: formProps.values.language,
    //         subject: formProps.values.subject,
    //         body: editorContent,
    //         createdAt: timestamp,
    //         updatedAt: timestamp,
    //       };
    //       // Push to array (state)
    //       setTemplates((prevTemplates) => [...prevTemplates, templateObject]);
    //     }
    //   }

    //   const foundTemplate =
    //     templates.length > 0
    //       ? templates.find((t) => t.languageKey == langCode)
    //       : {};
    //   if (foundTemplate) {
    //     setSubject(foundTemplate.subject || "");
    //     formProps.form.change("subject", foundTemplate.subject || "");
    //     setBody(foundTemplate.body || "");
    //   }
    // }
    // if (isEdit == true) {
    // console.log(formProps);
    GetContentRequest({ id: id, key: e });
    formProps.form.change("subject", subject);
  };

  const handleKeyDown = (e) => {
    if (!showSuggestions) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedIndex((prev) =>
        prev < filteredSuggestions.length - 1 ? prev + 1 : 0
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex((prev) =>
        prev > 0 ? prev - 1 : filteredSuggestions.length - 1
      );
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (highlightedIndex >= 0) {
        selectSuggestion(filteredSuggestions[highlightedIndex]);
      }
    } else if (e.key === "Escape") {
      setShowSuggestions(false);
    }
  };

  useEffect(() => {
    if (highlightedIndex >= 0 && itemRefs.current[highlightedIndex]) {
      itemRefs.current[highlightedIndex].scrollIntoView({
        block: "nearest",
        behavior: "smooth",
      });
    }
  }, [highlightedIndex]);

  const handleNotificationNameChange = (value) => {
    setNotificationName(value);
    if (value.trim() !== "") {
      dispatch({
        type: "notifications/NotificationAlreadyExist",
        payload: { templateName: value, id: id },
      });
    }
  };

  useEffect(() => {
    dispatch({ type: "notifications/ResetNotificationStatus" });
  }, [dispatch]);

  // Users / roles / cohorts placeholders
  const [prePopulatedUsers, setPrePopulatedUsers] = useState([]);
  const [prePopulatedRoles, setPrePopulatedRoles] = useState([]);
  const [prePopulatedCohorts, setPrePopulatedCohorts] = useState([]);
  // Saved role or cohort recipients whose kind is not known yet: neither the
  // role list nor the cohort list loaded so far has them (both are one page).
  // They are still saved, and move to the roles or cohorts once a list shows
  // them.
  const [otherAudience, setOtherAudience] = useState([]);

  const [isEdit, setIsEdit] = useState(false);
  const [isCustomEdit, setIsCustomEdit] = useState(false);
  const [isClone, setIsClone] = useState(false);

  const [showUsers, setShowUsers] = useState(false);
  const [showRoles, setShowRoles] = useState(false);
  const [transformed, setTransformed] = useState({});
  const [visible, setVisible] = useState(false);
  const [visibleCoh, setVisibleCoh] = useState(false);
  // The Roles dialog's search and paging, like the Cohorts dialog's below.
  const [queryRole, setQueryRole] = useState({
    search: "",
    pageNo: 1,
    pageSize: 10,
  });

  // The audience ids of the recipients last loaded or saved (the copy a tab
  // change or Cancel puts back is sorted from it).
  const savedAudienceTo = useRef(null);

  const handleSaveTab5 = (selected) => {
    setSelectedRoles(selected || []);
  };
  const handleSaveTab4 = (selected) => {
    setSelectedCohorts(selected || []);
  };

  const handleSaveTab2 = (selected) => {
    setSelectedUsers(selected || []);
  };

  const [selectedCohorts, setSelectedCohorts] = useState([]);
  // The Select Users dialog's own search (not usersSlice's query, E2E11)
  const { query, setQuery, fetchUsers } = useUserPicker(dispatch);

  const users = useSelector((state) => state.users.data.list || NO_ROWS);
  const totalCount = useSelector((state) => state.users.data?.length || 0);

  const totalCountAud = useSelector(
    (state) => state.audiences.data?.length || 0
  );

  const audience = useSelector((state) => state.audiences.data || NO_ROWS);

  const rolesData = useSelector(
    (state) => state.roles?.allRoles?.list || NO_ROWS
  );

  // Which audience ids are roles and which are cohorts, as far as the lists
  // loaded since the screen opened tell (review I-1, audienceRecipients.js).
  const audienceKinds = useAudienceKinds(rolesData, audience?.list);

  const [queryAud, setQueryAud] = useState({
    search: "",
    pageNo: 1,
    pageSize: 10,
  });

  const totalCountRoles = useSelector(
    (state) => state.roles.allRoles?.list?.length || 0
  );

  var formattedRoles = useMemo(
    () =>
      rolesData.map((role, idx) => ({
        id: role.id || idx + 1,
        name: role.name,
        userCount: role.userCount,
      })),
    [rolesData]
  );

  const fetchRoles = useCallback(
    (searchTerm = "") => {
      dispatch(
        getRolesRequest({
          query: { ...PICKER_BASE_QUERY, search: searchTerm },
        })
      );
    },
    [dispatch]
  );

  const fetchCohorts = useCallback(
    (searchTerm = "") => {
      dispatch(
        audienceListRequest({
          query: { ...PICKER_BASE_QUERY, search: searchTerm },
        })
      );
    },
    [dispatch]
  );

  var formattedCohorts = useMemo(
    () =>
      audience.list?.map((aud, idx) => ({
        id: aud.id || idx + 1,
        name: aud.name,
        userCount: aud.userCount,
      })),
    [audience.list]
  );

  // What the persisted store held when this screen opened: answers kept
  // from an earlier visit, possibly of another notification. The loads
  // started below replace them, so only answers that arrive after the
  // screen opened are applied.
  const atOpen = useRef({
    response,
    content,
    newUpadtedNotificationContent,
    updatedRecipant,
  });

    useEffect(() => {
      response = {}
    fetchRoles();
    fetchCohorts();
    fetchUsers();

    GetOthersCategoryRequest();
    GetNotificationClone({ id: id });   
    GetContentRequest({ id: id, key: "en" });
    integrationSubtypesRequest({
      type: 7,
      subtype: "Google_Gemini",
    });
  }, []);

  useEffect(() => {
    if (content && content !== atOpen.current.content) {
      // The saved content of this language is what a tab change puts back
      // (RevertToOriginalValues finds it by languageKey), so the key is kept
      // with it. It used to be dropped here, and after a content save the
      // Content tab went blank on the next tab change (F-BUG-10).
      const saved = {
        ...(content.id ? { id: content.id } : {}),
        languageKey: content.languageKey || "en",
        subject: content.subject || "",
        body: content.body || "",
      };
      setContentPrev((prev) =>
        prev.some((c) => c.languageKey === saved.languageKey)
          ? prev.map((c) =>
              c.languageKey === saved.languageKey ? { ...c, ...saved } : c
            )
          : [...prev, saved]
      );
      setSubject(content.subject || "");
      setBody(content.body || "");
    }
  }, [content]);

  //   useEffect(() => {
  //     // if initial contains a default english template, populate fields
  //     const en = templates.find((t) => t.languageKey === "en");
  //     if (en) {
  //       setSelectedLanguage("en");
  //       setSubject(en.subject || "");
  //       setEditorBody(en.body || "");
  //     }
  //   }, [templates]);

  //   const addTemplate = (values, form) => {
  //     const body = editorRef.current
  //       ? editorRef.current.getContent()
  //       : editorBody;
  //     if (!values.language) return;
  //     const obj = {
  //       languageKey: values.language,
  //       subject: values.subject || subject,
  //       body,
  //       createdAt: new Date().toISOString(),
  //     };
  //     setTemplates((prev) => {
  //       // replace same language if exists
  //       const filtered = prev.filter((t) => t.languageKey !== obj.languageKey);
  //       return [...filtered, obj];
  //     });
  //     // reset form fields
  //     form.change("subject", "");
  //     form.change("language", "");
  //     setSubject("");
  //     setEditorBody("");
  //     if (editorRef.current) editorRef.current.setContent("");
  //   };

  //   const handleSaveAll = () => {
  //     const payload = {
  //       name,
  //       category,
  //       urgency,
  //       startDate,
  //       startTime,
  //       timezone,
  //       templates,
  //       recipients: {
  //         users: selectedUsers,
  //         roles: selectedRoles,
  //       },
  //       channels: Object.keys(channels).filter((k) => channels[k]),
  //     };

  //     if (onSave) onSave(payload);
  //     else console.log("Save payload:\n", payload);
  //   };


  var formattedUsers = useMemo(
    () =>
      users.map((user, idx) => ({
        id: user?.id || idx + 1,
        name:
          user.name || `${user.firstName || ""} ${user.lastName || ""}`.trim(), // combine firstName/lastName if needed
        email: user.email || "", // default to empty string if missing,
        value: false,
      })),
    [users]
  );

  const getLanguageName = (key) => {
    const mapping = {
      de: "German",
      en: "English",
      "fr-CA": "French (Canada)",
      mn: "Mongolian",
      ru: "Russian",
      id: "Indonesian",
      "es-LA": "Spanish (Latin America)",
      es: "Spanish",
    };

    if (!mapping[key]) {
      return transformed[key]?.name;
    }
    return mapping[key] || key;
  };

  const addTemplateToList = () => {};

  const handleTabChange = (index) => {};

  useEffect(() => {
    if (newUpadtedNotificationContent === atOpen.current.newUpadtedNotificationContent) {
      // Kept from an earlier edit (any notification): not this screen's save.
      return;
    }
    setNotificationName(newUpadtedNotificationContent?.name);
    setCurrentNotificationName(newUpadtedNotificationContent?.name);
    setUrgencyFlag(newUpadtedNotificationContent?.urgencyFlag);
    // A notification stored without a time zone (saved before the API
    // required one, or a system notification saved through
    // UpdateCustomNotification, which still accepts none): pre-fill the
    // admin's own browser zone, since UpdateNotificationBasicContent always
    // needs a known one and would otherwise refuse this screen's own save
    // with 400 INVALID_TIMEZONE.
    const loadedTimeZone =
      newUpadtedNotificationContent?.timeZone || defaultTimezone();
    setTimezone(loadedTimeZone);

    // The day and time in the notification's own time zone (F-BUG-14).
    const sendAt = fromExecutionDate(
      newUpadtedNotificationContent?.execuationDate,
      loadedTimeZone
    );

    setStartDate(sendAt.date);
    setStartTime(sendAt.time);

    formStateRef?.current?.change("start_date", sendAt.pickerDate);
    formStateRef?.current?.change("start_time", sendAt.time);
    formStateRef?.current?.change("timezone", loadedTimeZone);

    setBasicInfoPrev({
      notificationId: newUpadtedNotificationContent?.id,
      name: newUpadtedNotificationContent?.name,
      categoryId: newUpadtedNotificationContent?.categoryId,
      urgencyFlag: newUpadtedNotificationContent?.urgencyFlag,
      execuationDate: newUpadtedNotificationContent?.execuationDate,
      timeZone: loadedTimeZone,
    });

    setIsEditable(false);
  }, [newUpadtedNotificationContent]);

  useEffect(() => {
    if (updatedRecipant === atOpen.current.updatedRecipant) {
      // Kept from an earlier edit (any notification): not this screen's save.
      return;
    }

    setPrePopulatedUsers(updatedRecipant?.userTo || []);

    const saved = splitAudience(updatedRecipant?.audienceTo, audienceKinds);
    setPrePopulatedCohorts(saved.cohorts);
    setPrePopulatedRoles(saved.roles);
    setOtherAudience(saved.other);
    savedAudienceTo.current = updatedRecipant?.audienceTo || [];

    setRecipantsPrev({ userTo: updatedRecipant?.userTo || [], ...saved });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedRecipant]);

  //----------------------------------------------------------------


  function RevertToOriginalValues() {
    if (activeTab === 0) {
      formStateRef?.current?.change("name", basicInfoPrev?.name);

      setNotificationName(basicInfoPrev?.name);
      setCurrentNotificationName(basicInfoPrev?.name);
      setUrgencyFlag(basicInfoPrev?.urgencyFlag);
      // basicInfoPrev.timeZone is already the browser zone when the
      // notification had none (see the load effects above), kept here only
      // as a defensive fallback.
      const revertedTimeZone = basicInfoPrev?.timeZone || defaultTimezone();
      setTimezone(revertedTimeZone);

      const sendAt = fromExecutionDate(
        basicInfoPrev?.execuationDate,
        revertedTimeZone
      );

      setStartDate(sendAt.date);
      setStartTime(sendAt.time);

      formStateRef?.current?.change("start_date", sendAt.pickerDate);
      formStateRef?.current?.change("start_time", sendAt.time);
      formStateRef?.current?.change("timezone", revertedTimeZone);
    } else if (activeTab === 2) {
      setPrePopulatedUsers(recipantsPrev?.userTo || []);
      setPrePopulatedCohorts(recipantsPrev?.cohorts || []);
      setPrePopulatedRoles(recipantsPrev?.roles || []);
      setOtherAudience(recipantsPrev?.other || []);
    } else if (activeTab === 1) {
      const content_data = contentPrev.find((c) => c.languageKey === "en");

      setSubject(content_data?.subject || "");
      setBody(content_data?.body || "");
    }
  }

  useEffect(() => {
    setTransformed(
      LANGUAGES.reduce((acc, lang) => {
        acc[lang.code] = lang;
        return acc;
      }, {})
    );
  }, []);

  // The loaded notification is applied once per answer. It used to be
  // applied again whenever the role or cohort list changed (they were
  // dependencies here), which put the loaded recipients, name, date and
  // content back over the admin's unsaved changes, for example when a
  // dialog's search reloaded a list.
  useEffect(() => {
    if (response === atOpen.current.response) {
      // Kept from an earlier visit: the load started on open replaces it.
      return;
    }
    if (response && response?.notificationContents) {
      setNotificationName(response.name || "");
      setCurrentNotificationName(response.name || "");
      setCategoryName(response.categoryName || "");
      // The day and the 24-hour time in the notification's own time zone.
      // The time was read as "hh:mm" (12-hour, no AM or PM), so a save sent
      // an afternoon time back as the morning (F-BUG-4), and in the
      // browser's zone (F-BUG-14).
      // A notification stored without a time zone: pre-fill the admin's own
      // browser zone (the builder default, NotificationSchedule.
      // defaultTimezone), since UpdateNotificationBasicContent always needs
      // a known zone and would otherwise refuse this screen's own save with
      // 400 INVALID_TIMEZONE.
      const loadedTimeZone = response.timeZone || defaultTimezone();
      const sendAt = fromExecutionDate(
        response.execuationDate,
        loadedTimeZone
      );

      setStartDate(sendAt.date);
      setStartTime(sendAt.time);

      setPrePopulatedUsers(response.userTo || []);

      const saved = splitAudience(response.audienceTo, audienceKinds);
      setPrePopulatedCohorts(saved.cohorts);
      setPrePopulatedRoles(saved.roles);
      setOtherAudience(saved.other);
      savedAudienceTo.current = response.audienceTo || [];

      setRecipantsPrev({ userTo: response.userTo || [], ...saved });

      setSubject(
        response?.notificationContents?.find((c) => c.languageKey === "en")
          .subject || ""
      );

      setBody(
        response?.notificationContents?.find((c) => c.languageKey === "en")
          .body || ""
      );

      setUrgencyFlag(response?.urgencyFlag);

      setTimezone(loadedTimeZone);
      formStateRef?.current.change("start_date", sendAt.pickerDate);
      // start_time is validated as required (M2); keep final-form's own
      // value for it in step with the local state, or a save made without
      // ever touching the field would see it as still empty and be blocked.
      formStateRef?.current.change("start_time", sendAt.time);
      formStateRef?.current.change("timezone", loadedTimeZone);
      setPlaceholders(response.placeHolders);
      setShowUsers(response.isUserRecepient || false);
      setLanguages(
        (response.allowedLanguage || []).map((c) => ({
          code: c,
          name: getLanguageName(c),
        }))
      );
      setSelectedLanguage("en");

      const contents = response?.notificationContents.map((contentItem) => {
        return {
          // The content's own id: a content save must update this content.
          id: contentItem.id,
          languageKey: contentItem.languageKey,
          subject: contentItem.subject,
          body: contentItem.body,
        };
      });

      setContentPrev(contents);

      //   const channelArray = response.channel; // e.g. ["email", "NotificationWidgets"]

      //   // Convert to object matching your state shape
      //   const newChannels = channelList.reduce((acc, item) => {
      //     acc[item.key] = channelArray.includes(item.key);
      //     return acc;
      //   }, {});
      //   setChannels(newChannels);

      setBasicInfoPrev({
        notificationId: response.id,
        name: response.name,
        categoryId: response.categoryId,
        urgencyFlag: response.urgencyFlag,
        execuationDate: response.execuationDate,
        timeZone: loadedTimeZone,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [response]);

  // A role or cohort list that loads (or a dialog's search result) can tell
  // the kind of saved recipients that were not known yet: they move to the
  // roles or cohorts. Nothing else changes, so a list that no longer shows
  // a recipient never drops it, and the admin's own changes stay.
  useEffect(() => {
    if (otherAudience.length > 0) {
      const known = splitAudience(otherAudience, audienceKinds);
      if (known.roles.length > 0 || known.cohorts.length > 0) {
        setPrePopulatedRoles((prev) => joinAudience(prev, known.roles));
        setPrePopulatedCohorts((prev) => joinAudience(prev, known.cohorts));
        setOtherAudience(known.other);
      }
    }
    if (savedAudienceTo.current) {
      const saved = splitAudience(savedAudienceTo.current, audienceKinds);
      setRecipantsPrev((prev) => ({ ...prev, ...saved }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [audience, rolesData]);

  useEffect(() => {
    if (categoryData) {
      setCategoryName(categoryData.name);
      setSelectedCategoryId(categoryData.id);
      setPlaceholders(categoryData.placeHolders);
      setLanguages(
        (categoryData.allowedLanguages || []).map((c) => ({
          code: c,
          name: getLanguageName(c),
        }))
      );
    }
  }, [categoryData]);



  // AI Write runs through the API with the stored Gemini key (PX-2).
  const aiWriteAvailable = isAiWriteAvailable(integrations);


const getScrollParent = (node) => {
    if (!node) return window;
    let parent = node.parentElement;
    while (parent) {
      const style = window.getComputedStyle(parent);
      const overflowY = style.overflowY;
      const isScrollable =
        overflowY &&
        (overflowY === "auto" ||
          overflowY === "scroll" ||
          overflowY === "overlay");
      if (isScrollable && parent.scrollHeight > parent.clientHeight)
        return parent;
      parent = parent.parentElement;
    }
    return window;
  };
 
 
    const calculatePosition = useCallback(() => {
      const el = inputWrapperRef.current;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      // use page coordinates since portal is in document.body and we use absolute positioning
      setDropdownPos({
        top: rect.bottom + window.scrollY, // absolute page Y
        left: rect.left + window.scrollX, // absolute page X
        width: rect.width,
      });
    }, []);
 
    useEffect(() => {
      if (!showSuggestions) return; // only active when dropdown visible
 
      // measure immediately when opening
      calculatePosition();
 
      const scrollParent = getScrollParent(inputWrapperRef.current);
      // handlers
      const onScroll = () => calculatePosition();
      const onResize = () => calculatePosition();
      const onKey = (e) => {
        if (e.key === "Escape") {
          // close dropdown, make sure you control showSuggestions from state
          // setShowSuggestions(false);
        }
      };
 
      const onDocClick = (e) => {
        // close when click outside input or dropdown
        if (
          inputWrapperRef.current &&
          !inputWrapperRef.current.contains(e.target) &&
          dropdownRef.current &&
          !dropdownRef.current.contains(e.target)
        ) {
          // setShowSuggestions(false);
        }
      };
 
      // attach scroll listener to the nearest scrollable parent (or window)
      if (scrollParent === window) {
        window.addEventListener("scroll", onScroll, { passive: true });
      } else {
        scrollParent.addEventListener("scroll", onScroll, { passive: true });
      }
      window.addEventListener("scroll", onScroll, { passive: true }); // in case page scrolls too
      window.addEventListener("resize", onResize);
      document.addEventListener("keydown", onKey);
      document.addEventListener("click", onDocClick);
 
      // optional: observe size changes of input wrapper (e.g., responsive layout)
      let resizeObserver;
      if (window.ResizeObserver && inputWrapperRef.current) {
        resizeObserver = new ResizeObserver(() => calculatePosition());
        resizeObserver.observe(inputWrapperRef.current);
      }
 
      return () => {
        if (scrollParent === window) {
          window.removeEventListener("scroll", onScroll);
        } else {
          scrollParent.removeEventListener("scroll", onScroll);
        }
        window.removeEventListener("scroll", onScroll);
        window.removeEventListener("resize", onResize);
        document.removeEventListener("keydown", onKey);
        document.removeEventListener("click", onDocClick);
        if (resizeObserver && inputWrapperRef.current)
          resizeObserver.unobserve(inputWrapperRef.current);
      };
    }, [showSuggestions, calculatePosition]);

  const tabs = [
    { label: "Basic Info", command: () => setActiveTab(0) },
    { label: "Content", command: () => setActiveTab(1) },
    { label: "Recipient", command: () => setActiveTab(2) },
    { label: "Channels", command: () => setActiveTab(3) },
  ];

  return (
    <div>
      <CustomBreadCrumbs
        labels={[
          { label: "Notifications", to: "/notifications" }, // Parent page
          { label: `${currentNotificationName}` }, // Current page
        ]}
        navigate={navigate}
      />
      <div className="edexlms-page-content">
        <div className="edexlms-page-header">
          <div className="edexlms-page-title">
            {intl.formatMessage({ id: "edit_notification" })}
          </div>
          {[0, 1, 2].includes(activeTab) && (
            <Button
              label={intl.formatMessage({ id: "edit" })}
              icon="pi pi-pencil"
              className="p-button-sm p-button-outlined"
              onClick={() => setIsEditable(true)}
            />
          )}
        </div>

        <div
          className="edexlms-page-body"
          style={{
            height: "calc(100vh - 64px - 20px - 45px - 40px - 14px - 40px)",
            overflowY: "scroll",
          }}
        >
          {activeTab !== null && (
            <TabMenu
              className="edexlms-tab-menu"
              model={[
                {
                  label: intl.formatMessage({ id: "basic_info" }),

                  command: () => {
                    handleTabChange(0);
                  },
                },
                {
                  label: intl.formatMessage({ id: "content" }),

                  command: () => {
                    handleTabChange(1);
                  },
                },
                {
                  label: intl.formatMessage({ id: "recipient" }),

                  command: () => {
                    handleTabChange(2);
                  },
                },
                {
                  label: intl.formatMessage({ id: "channels" }),
                  command: () => {
                    handleTabChange(3);
                  },
                },
              ]}
              activeIndex={activeTab} // ✅ bind active tab
              onTabChange={(e) => {
                RevertToOriginalValues();
                setActiveTab(e.index);
                if (e.index !== activeTab) {
                  setIsEditable(false);
                }
              }}
            />
          )}

          {/* ✅ Wrap fields inside Form */}
          <Form
            onSubmit={(values) => {
              if (activeTab === 0) {
                if (notiStatus?.notiStatus?.response === true) {
                  return; // stop here, show error messages
                }

                updateNotiBasicInfo({
                  data: {
                    NotificationId: response.id,
                    Name: notificationName,
                    CategoryId: categoryData.id,
                    UrgencyFlag: urgencyFlag,
                    // The chosen day and time in the chosen time zone. Built
                    // in the browser's zone before (F-BUG-14), and the day
                    // kept as text was read as UTC midnight, the day before
                    // in a browser west of UTC.
                    ExecuationDate: toExecutionDate(
                      startDate,
                      startTime,
                      timezone
                    ),
                    TimeZone: timezone,
                  },
                });
                GetContentRequest({ id: id, key: "en" });
              } else if (activeTab === 1) {
                if ((body == "" || subject == "") && activeTab == 1) {
                  toast.error(
                    customIntl.formatMessage({
                      id: "body_content",
                    })
                  );
                  return; // stop execution
                }

                // The id of this notification's content in the language
                // saved. It used to be the content last loaded into the
                // store, or the notification's own id when that had not
                // loaded yet, and the API then added a second content in
                // that language instead of updating it (F-BUG-13). A
                // language without content yet is still sent with the
                // notification id, which adds it.
                const data = {
                  Id:
                    contentPrev.find((c) => c.languageKey === values.language)
                      ?.id ||
                    (content?.languageKey === values.language && content?.id) ||
                    response.id,
                  LanguageKey: values.language,
                  Body: editorRef.current
                    ? editorRef.current.getContent()
                    : body,
                  Subject: subject,
                  NotificationId: response.id,
                };
                if (
                  data.LanguageKey === "en" &&
                  (!data.Body || data.Body.trim() === "")
                ) {
                  toast.error(
                    customIntl.formatMessage({
                      id: "validation_for_Content",
                    })
                  );
                  return;
                }
                updateNotificationContentRequest({ data: data });
                setIsEditable(false);
              } else if (activeTab === 2) {
                if (
                  prePopulatedUsers.length === 0 &&
                  prePopulatedRoles.length === 0 &&
                  prePopulatedCohorts.length === 0 &&
                  otherAudience.length === 0 &&
                  activeTab == 2
                ) {
                  toast.error(
                    customIntl.formatMessage({
                      id: "validation_recipient",
                    })
                  );
                  return; // stop execution
                }
                updateCustomNotiRecipant({
                  data: {
                    NotificationId: response.id,
                    UserRecepient: [...prePopulatedUsers],
                    // Every role and cohort recipient, also those whose kind
                    // the lists loaded so far do not tell (review I-1).
                    AudienceTo: joinAudience(
                      prePopulatedCohorts,
                      prePopulatedRoles,
                      otherAudience
                    ),
                  },
                });
                setIsEditable(false);
                GetContentRequest({ id: id, key: "en" });
              }
            }}
            render={(formikProps) => {
              const { handleSubmit, form, values } = formikProps; // destructure form from it
              // store current form instance in ref instead of global var
              formStateRef.current = form;
              return (
                <form onSubmit={formikProps.handleSubmit}>
                  {activeTab === 0 && (
                    <div className="flex flex-column gap-4 relative">
                      {!isEditable ? (
                        // ---------------- Edit Mode ----------------
                        <div className="flex flex-column gap-3 border-round p-2">
                          <Section title="general">
                            <div className="flex flex-column gap-2">
                              <div className="grid">
                                {/* Name */}
                                <div className="col-12 md:col-6 lg:col-4">
                                  <label
                                    className="text-gray-500"
                                    style={{
                                      fontColor: "#64748b",
                                      fontSize: "12px",
                                      fontWeight: "400",
                                    }}
                                  >
                                    {intl.formatMessage({ id: "name" })}
                                  </label>
                                  <div className="text-gray-600 mt-1">
                                    {/* {apiData?.name || "-"} */}
                                    {/* {"Shivani"} */}
                                    {notificationName || "-"}
                                  </div>
                                </div>

                                {/* Category */}
                                <div className="col-12 md:col-6 lg:col-4">
                                  <label
                                    className="text-gray-500"
                                    style={{
                                      fontColor: "#64748b",
                                      fontSize: "12px",
                                      fontWeight: "400",
                                    }}
                                  >
                                    {intl.formatMessage({ id: "category" })}
                                  </label>
                                  <div className="text-gray-600 mt-1">
                                    {/* {apiData?.category || "-"} */}
                                    {/* {"Program"} */}
                                    {categoryName || "-"}
                                  </div>
                                </div>
                                {/* urgency flag */}
                                <div className="col-12 md:col-6 lg:col-4">
                                  <label
                                    className="text-gray-500"
                                    style={{
                                      fontColor: "#64748b",
                                      fontSize: "12px",
                                      fontWeight: "400",
                                    }}
                                  >
                                    {intl.formatMessage({ id: "urgency_flag" })}
                                  </label>
                                  <div className="text-gray-600 mt-1">
                                    {/* {apiData?.category || "-"} */}
                                    {/* {"Program"} */}
                                    {urgencyFlag === 0
                                      ? "Normal"
                                      : "High Priority"}
                                  </div>
                                </div>

                                <div className="col-12 md:col-6 lg:col-4">
                                  <label
                                    className="text-gray-500"
                                    style={{
                                      fontColor: "#64748b",
                                      fontSize: "12px",
                                      fontWeight: "400",
                                    }}
                                  >
                                    {intl.formatMessage({
                                      id: "notification_date",
                                    })}
                                  </label>
                                  <div className="text-gray-600 mt-1">
                                    {/* {apiData?.category || "-"} */}
                                    {/* {"Program"} */}
                                    {/* {startDate && new Date(startDate) } */}
                                    {startDate}
                                  </div>
                                </div>
                                <div className="col-12 md:col-6 lg:col-4">
                                  <label
                                    className="text-gray-500"
                                    style={{
                                      fontColor: "#64748b",
                                      fontSize: "12px",
                                      fontWeight: "400",
                                    }}
                                  >
                                    {intl.formatMessage({
                                      id: "notification_time",
                                    })}
                                  </label>
                                  <div className="text-gray-600 mt-1">
                                    {/* {apiData?.category || "-"} */}
                                    {/* {"Program"} */}
                                    {`${startTime}`}
                                  </div>
                                </div>
                                <div className="col-12 md:col-6 lg:col-4">
                                  <label
                                    className="text-gray-500"
                                    style={{
                                      fontColor: "#64748b",
                                      fontSize: "12px",
                                      fontWeight: "400",
                                    }}
                                  >
                                    {intl.formatMessage({
                                      id: "timezone",
                                    })}
                                  </label>
                                  <div className="text-gray-600 mt-1">
                                    {/* {apiData?.category || "-"} */}
                                    {/* {"Program"} */}
                                    {timezone}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Section>
                        </div>
                      ) : (
                        <div className="flex flex-column gap-4">
                          {/* ---------------- Name ---------------- */}

                          <div className="col-12 flex flex-column gap-2">
                            <label htmlFor="name">
                              {intl.formatMessage({ id: "name" })}
                            </label>
                            <Field
                              id="name"
                              name="name"
                              initialValue={notificationName}
                              component={TextInputNoti}
                              type="text"
                              placeholder={intl.formatMessage({
                                id: "enter_template_name",
                              })}
                              onChange={(value) => {
                                setNotificationName(value);
                                handleNotificationNameChange(value);
                              }}
                              required
                              validate={Validations.composeValidators(
                                Validations.required
                              )}
                              style={{ width: "100%" }}
                            />
                            {requesting && <small>Checking name...</small>}
                            {notiStatus?.notiStatus?.response === true && (
                              <div
                                class="edexlms-field-error"
                                style={{ color: "#d9342b" }} // only override color
                              >
                                Notification name already exists
                              </div>
                            )}
                          </div>

                          {/* ---------------- Category + Urgency Flag in Same Row ---------------- */}
                          <div className="flex flex-row gap-4 w-full">
                            <div
                              className="col-12 md:col-6 flex flex-column gap-2"
                              style={{ width: "50%" }}
                            >
                              <label>
                                {intl.formatMessage({ id: "category" })}
                              </label>

                              <Field
                                name="category"
                                component={TextInputNoti}
                                value="Others"
                                input={{
                                  value: "Others",
                                  readOnly: true,
                                  disabled: true,
                                }}
                              />
                            </div>
                            {/* Urgency Flag */}
                            <div
                              className="col-12 md:col-6 flex flex-column gap-2"
                              style={{ width: "48.1%" }}
                            >
                              <DropdownInputUF
                                label={intl.formatMessage({
                                  id: "urgency_flag",
                                })}
                                options={urgencyOptions}
                                value={urgencyFlag} // 0 or 1
                                onChange={setUrgencyFlag} // updates local state
                                placeholder={intl.formatMessage({
                                  id: "select_flag",
                                })}
                                required
                              />
                            </div>
                          </div>

                          {/* Date */}
                          <div className="grid">
                            <div className="col-12 md:col-6 lg:col-4">
                              <Field
                                appendTo={document.body}
                                key={`dp-${calendarKey}`}
                                name="start_date"
                                component={DatePicker}
                                label={intl.formatMessage({ id: "start_date" })}
                                placeholder={intl.formatMessage({
                                  id: "start_date_place_holder",
                                })}
                                onChange={(e) => {
                                  const date = e;

                                  setStartDate(date); // if using formik
                                }}
                                required
                                // minDate={new Date()}
                                validate={Validations.composeValidators(
                                  Validations.required
                                )}
                              />
                            </div>

                            <div className="col-12 md:col-6 lg:col-4">
                              <Field
                                timeValue={startTime}
                                name="start_time"
                                component={TextInputNoti}
                                type="time"
                                label={intl.formatMessage({ id: "start_time" })}
                                placeholder={intl.formatMessage({
                                  id: "start_time_place_holder",
                                })}
                                onChange={(value) => {
                                  setStartTime(value);
                                }} // ✅ now works
                                // step="1"                                   // ✅ show seconds
                                required
                                // M2 (phase2-P-UI-2-review): this was
                                // commented out, so clearing the time built
                                // ExecuationDate: null (a non-nullable
                                // DateTime on the API, refused with a model-
                                // binding 400) instead of a field error.
                                // final-form blocks the submit while this
                                // field is invalid (see its submit()), so
                                // re-enabling it also stops the send.
                                validate={Validations.composeValidators(
                                  Validations.required
                                )}
                              />
                            </div>

                            <div className="col-12 md:col-6 lg:col-4">
                              <Field
                                name="timezone"
                                component={DropdownInput}
                                label={intl.formatMessage({ id: "timezone" })}
                                options={Intl.supportedValuesOf("timeZone").map(
                                  (tz) => ({
                                    name: tz,
                                    value: tz,
                                  })
                                )}
                                placeholder={intl.formatMessage({
                                  id: "timezone",
                                })}
                                onChange={(value) => setTimezone(value)}
                                defaultValue={defaultTimezone()}
                                required
                                validate={Validations.composeValidators(
                                  Validations.required
                                )}
                                filter={true} // ✅ enables search
                                filterBy="name" // ✅ ensures it searches the "name" property
                                showClear={true} // ✅ adds "x" icon to clear
                              />
                            </div>
                          </div>
                          {/* ---------------- Checkbox ---------------- */}
                          <div className="w-full flex items-center gap-2 border p-1 rounded">
                            {" "}
                            <style>{`
        .p-checkbox .p-checkbox-box {
          width: 16px;
          height: 16px;
          border: 2px solid black;
          border-radius: 2px;
        }
        .p-checkbox .p-checkbox-box.p-highlight {
          background-color: black;
          border-color: black;
        }
        .p-checkbox .p-checkbox-box.p-highlight::after {
          border-color: white;
          border-width: 2px;
        }
      `}</style>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  {activeTab === 1 && (
                    <div className="p-0.5">
                      {!isEditable ? (
                        <div className="flex flex-column gap-3 border-round p-2 surface-card">
                          <Section title="email_template">
                            <div className="flex flex-column gap-2">
                              <div className="grid">
                                {/* Name */}
                                <div className="col-12 md:col-6 lg:col-4">
                                  <label
                                    className="text-gray-500"
                                    style={{
                                      fontColor: "#64748b",
                                      fontSize: "12px",
                                      fontWeight: "400",
                                    }}
                                  >
                                    {intl.formatMessage({ id: "subject" })}
                                  </label>
                                  <div className="text-gray-600 mt-1">
                                    {/* {apiData?.name || "-"} */}
                                    {/* {"New Cybersecurity Awareness Training Assigned"} */}
                                    {subject}
                                  </div>
                                </div>
                                <div className="col-12">
                                  <label
                                    className="text-gray-500"
                                    style={{
                                      fontColor: "#64748b",
                                      fontSize: "12px",
                                      fontWeight: "400",
                                    }}
                                  >
                                    {intl.formatMessage({ id: "body" })}
                                  </label>
                                  <div
                                    className="text-gray-600 mt-1"
                                    dangerouslySetInnerHTML={{ __html: body }}
                                  >
                                    {/* {apiData?.name || "-"} */}
                                    {/* {"Hello Judy,We’re excited to let you know that you’ve successfully completed the “Introduction to Stock Market Fundamentals” course.This is a big achievement, and we’re proud of the effort you’ve put into learning and growing your skills. You can now download your certificate and share it with your professional network.Keep going — your learning journey has just begun!Best regards,The Learning Team"} */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Section>
                        </div>
                      ) : (
                        <div>
                          <Section title="email_template">
                            <div className="mb-4">
                              <label
                                htmlFor="language"
                                className="block mb-1 font-medium"
                              >
                                {intl.formatMessage({ id: "select_language" })}
                              </label>

                              <Field
                                id="language"
                                name="language"
                                component={DropdownInput}
                                placeholder={intl.formatMessage({
                                  id: "select_language",
                                })}
                                initialValue={selectedLanguage}
                                options={
                                  languages && languages.length > 0
                                    ? languages.map((lang) => ({
                                        name: lang.name,
                                        value: lang.code,
                                      }))
                                    : [{ name: "", value: "" }]
                                }
                                required
                                validate={Validations.composeValidators(
                                  Validations.required
                                )}
                                style={{ width: "100%" }}
                                onChange={(value) => {
                                  handleLanguageChange(value, formikProps);
                                }} // receives langCode directly from DropdownInput
                              />
                            </div>

                            <div className="mb-4 relative">
                              <label
                                htmlFor="subject"
                                className="block mb-1 font-medium"
                              >
                                {intl.formatMessage({ id: "subject" })}
                              </label>

                              <div
                                ref={inputWrapperRef}
                                onKeyDown={handleKeyDown}
                                className="relative w-full"
                              >
                                <Field
                                  id="subject"
                                  name="subject"
                                  type="text"
                                  required={true}
                                  component={TextInputNoti}
                                  placeholder={intl.formatMessage({
                                    id: "enter_subject",
                                  })}
                                  initialValue={subject}
                                  input={{
                                    value: `${subject}`,
                                    // onChange: (e) => handleSubjectChange(e),
                                    onChange: (e) => {
                                      handleSubjectChange(e, formikProps);
                                    }, // receives langCode directly from DropdownInput
                                  }}
                                  validate={Validations.composeValidators(
                                    Validations.required
                                  )}
                                  style={{ width: "100%" }}
                                />
                              </div>

                              {showSuggestions &&
                                createPortal(
                                  <div
                                    ref={dropdownRef}
                                    style={{
                                      position: "absolute",
                                      top: dropdownPos.top, // page coords
                                      left: dropdownPos.left,
                                      width: dropdownPos.width,
                                      background: "white",
                                      border: "1px solid #ccc",
                                      borderRadius: 6,
                                      boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
                                      maxHeight: 200,
                                      overflowY: "auto",
                                      zIndex: 999999,
                                    }}
                                  >
                                    {filteredSuggestions.map((sugg, index) => (
                                      <div
                                        ref={(el) =>
                                          (itemRefs.current[index] = el)
                                        }
                                        key={sugg}
                                        className={`px-3 py-2 cursor-pointer hover:bg-gray-100 ${
                                          index === highlightedIndex &&
                                          "bg-gray-100"
                                        }`}
                                        onClick={() => {
                                          selectSuggestion(sugg);
                                          // setShowSuggestions(false); // close
                                        }}
                                      >
                                        {`${sugg}`}
                                      </div>
                                    ))}
                                  </div>,
                                  document.body
                                )}
                            </div>

                            {/* Body */}
                            <div className="mb-4">
                              <label className="block mb-1 font-medium">
                                Body
                              </label>
                              { content == null
                                && (
                                  <div className="edexlms-language-warning justify-content-center align-items-center pb-3">
                                  <Message
                                    severity="warn"
                                    text={
                                      <span>
                                        {intl.formatMessage({ id: "InValidLanguage" })}
                                      </span>
                                    }
                                  ></Message>
                                </div>
                                )
                              }
                              <Editor
                                tinymceScriptSrc="/tinymce/tinymce.min.js"
                                onInit={(evt, editor) =>
                                  (editorRef.current = editor)
                                }
                                initialValue={body}
                               
                                init={{
                                  height: 300,
                                  menubar: true,
                                   promotion: false,
                                  plugins: [
                                    "lists",
                                    "link",
                                    "autolink",
                                    "code",
                                    "advlist",
                                    "charmap",
                                    "searchreplace",
                                    "visualblocks",
                                    "fullscreen",
                                    "insertdatetime",
                                    "table",
                                    "help",
                                    "wordcount",
                                    // ,"fonts","format"
                                  ],

                                  toolbar:
                                    "formatselect | " +
                                    "bold italic underline strikethrough blockquote | " +
                                    "link| bullist numlist | " +
                                    "alignleft aligncenter alignright | " +
                                    "myLanguageDropdown |aiWriteButton | removeformat | help",
                                  license_key: "gpl",

                                  block_formats:
                                    "Paragraph=p; Heading 1=h1; Heading 2=h2; Heading 3=h3",

                                  content_style:
                                    "body { font-family: Arial, sans-serif; font-size:14px }",

                                  setup: (editor) => {
                                    const onAction = (
                                      autocompleteApi,
                                      rng,
                                      value
                                    ) => {
                                      editor.selection.setRng(rng);
                                      editor.insertContent(value);
                                      autocompleteApi.hide();
                                    };

                                    editor.on("keydown", (e) => {
                                      const isAutocompleteOpen =
                                        editor.dom.select(".tox-autocompleter").length > 0;
                                  
                                      if (e.key === "Enter" && !isAutocompleteOpen) {
                                        e.preventDefault();
                                        editor.execCommand("InsertLineBreak"); // inserts <br>
                                        editor.execCommand("mceInsertRawHTML", false, "<br>");
                                        return false;
                                      }
                                    });

                                    editor.ui.registry.addAutocompleter(
                                      "placeholders",
                                      {
                                        trigger: "{",
                                        minChars: 0,
                                        columns: 1,
                                        fetch: (pattern) => {
                                          return new Promise((resolve) => {
                                            const results = placeholders
                                              .filter((p) =>
                                                p
                                                  .toLowerCase()
                                                  .includes(
                                                    pattern.toLowerCase()
                                                  )
                                              )
                                              .map((p) => ({
                                                type: "autocompleteitem",
                                                value: `{{${p}}}`,
                                                text: p,
                                              }));
                                            resolve(results);
                                          });
                                        },
                                        onAction: onAction,
                                      }
                                    );

                                    // AI Write button
                                    if (aiWriteAvailable) {
                                      editor.ui.registry.addButton(
                                        "aiWriteButton",
                                        {
                                          text: "AI Write",
                                          icon: "comment",
                                          tooltip: "Generate content using AI",
                                          onAction: () => runAiWrite(editor),
                                        }
                                      );
                                    }
                                  },
                                }}
                                // onEditorChange={(content, editor) => setBody(content)}
                                onBlur={(e) => {
                                  const content =
                                    editorRef.current.getContent();
                                  setBody(content);
                                }}
                              />
                            </div>
                          </Section>
                        </div>
                      )}
                    </div>
                  )}
                  {activeTab === 2 && (
                    <div className="p-4">
                      <div className="mb-3 flex items-center justify-between border p-3 rounded bg-gray-100">
                        <Checkbox
                          inputId="users"
                          checked={prePopulatedUsers.length > 0}
                          onClick={
                            isEdit == false
                              ? () => setShowUsers(true)
                              : undefined
                          }
                          onChange={(e) => {
                            if (!isEdit) {
                              setShowUsers(e.checked); // only open dialog if not in edit mode
                            }
                          }}
                          // onChange={isEditable ? () => setShowUsers(true) : undefined}
                          disabled={isEdit == true}
                        />
                        <label htmlFor="users" className="ml-2 flex-1">
                          Users {` (${prePopulatedUsers.length})`}
                        </label>

                        {/* Select Button */}
                        {isEditable && (
                          <Button
                            type="button"
                            label="Select"
                            onClick={() => setShowUsers(true)}
                            size="small"
                            className="p-button-outlined bg-white text-black border border-black hover:bg-gray-100 px-2 py-1 text-xs h-7"
                          />
                        )}
                      </div>
                      {/* User List Dialog */}
                      {showUsers && (
                        <Dialog
                          header="All Users"
                          visible={showUsers}
                          modal
                          style={{
                            width: "60vw",
                            maxWidth: "800px",
                            position: "relative",
                          }}
                          onHide={() => setShowUsers(false)}
                          breakpoints={{ "960px": "75vw", "640px": "90vw" }}
                        >
                          <UserList
                            users={formattedUsers}
                            totalCount={totalCount}
                            query={query}
                            setQuery={setQuery}
                            fetchUsers={fetchUsers}
                            selectedUsers={selectedUsers} // ✅ pass selected users
                            setSelectedUsers={setSelectedUsers} // ✅ pass setter
                            onSave={(selectedUsers) => {
                              handleSaveTab2(selectedUsers);
                              setPrePopulatedUsers(
                                selectedUsers.map((u) => u.id)
                              );
                              setShowUsers(false);
                            }}
                            onCancel={() => setShowUsers(false)}
                            preSelectedIds={prePopulatedUsers || []}
                          />
                        </Dialog>
                      )}
                      <style>{`
        .p-checkbox .p-checkbox-box {
          width: 16px;
          height: 16px;
          border: 2px solid black;
          border-radius: 2px;
        }
        .p-checkbox .p-checkbox-box.p-highlight {
          background-color: black;
          border-color: black;
        }
        .p-checkbox .p-checkbox-box.p-highlight::after {
          border-color: white;
          border-width: 2px;
        }
      `}</style>

                      {/* Role(s) */}
                      <div className="mb-3 flex items-center justify-between border p-3 rounded bg-gray-100">
                        <Checkbox
                          inputId="roles"
                          checked={prePopulatedRoles.length > 0}
                          onChange={
                            isEdit == false ? () => setVisible(true) : undefined
                          }
                          disabled={isEdit == true}
                        />
                        <label htmlFor="roles" className="ml-2 flex-1">
                          Role
                          {`(${prePopulatedRoles.length})`}
                        </label>

                        {/* Select Button */}
                        {isEditable && (
                          <Button
                            type="button"
                            label="Select"
                            onClick={() => {
                              setVisible(true);
                            }}
                            size="small"
                            className="p-button-outlined bg-white text-black border border-black hover:bg-gray-100 px-2 py-1 text-xs h-7"
                          />
                        )}
                      </div>

                      {/* Roles Dialog */}
                      {visible && (
                        <Dialog
                          header="All Roles"
                          visible={visible}
                          modal
                          style={{
                            width: "60vw",
                            maxWidth: "800px",
                            position: "relative",
                          }}
                          onHide={() => {
                            setSelectedRoles(
                              toRecipients(prePopulatedRoles, formattedRoles)
                            );
                            setVisible(false);
                          }}
                          breakpoints={{ "960px": "75vw", "640px": "90vw" }}
                        >
                          <RoleList
                            roles={formattedRoles}
                            totalCount={totalCountRoles}
                            query={queryRole}
                            setQuery={setQueryRole}
                            fetchRoles={fetchRoles}
                            selectedRoles={selectedRoles} // ✅ pass selected users
                            setSelectedRoles={setSelectedRoles} // ✅ pass setter
                            onSave={(selectedRoles) => {
                              handleSaveTab5(selectedRoles);
                              setPrePopulatedRoles(
                                selectedRoles.map((u) => u.id)
                              );
                              setVisible(false);
                            }}
                            onCancel={() => {
                              setSelectedRoles(
                                toRecipients(prePopulatedRoles, formattedRoles)
                              );
                              setVisible(false);
                            }}
                            preSelectedIds={prePopulatedRoles || []}
                          />
                        </Dialog>
                      )}
                      <style>{`
        .p-checkbox .p-checkbox-box {
          width: 16px;
          height: 16px;
          border: 2px solid black;
          border-radius: 2px;
        }
        .p-checkbox .p-checkbox-box.p-highlight {
          background-color: black;
          border-color: black;
        }
        .p-checkbox .p-checkbox-box.p-highlight::after {
          border-color: white;
          border-width: 2px;
        }
      `}</style>
                      {/* /*Cohorts  */}
                      <div className="mb-3 flex items-center justify-between border p-3 rounded bg-gray-100">
                        <Checkbox
                          inputId="cohorts"
                          checked={prePopulatedCohorts.length > 0}
                          onChange={
                            isEdit == false
                              ? () => setVisibleCoh(true)
                              : undefined
                          }
                          disabled={isEdit == true}
                        />
                        <label htmlFor="cohorts" className="ml-2 flex-1">
                          Cohorts {`(${prePopulatedCohorts.length})`}
                        </label>

                        {/* Select Button */}
                        {isEditable && (
                          <Button
                            type="button"
                            label="Select"
                            onClick={() => setVisibleCoh(true)}
                            size="small"
                            className="p-button-outlined bg-white text-black border border-black hover:bg-gray-100 px-2 py-1 text-xs h-7"
                          />
                        )}
                      </div>

                      {/* Cohorts Dialog */}
                      {visibleCoh && (
                        <Dialog
                          header="All Cohorts"
                          visible={visibleCoh}
                          modal
                          style={{
                            width: "60vw",
                            maxWidth: "800px",
                            position: "relative",
                          }}
                          onHide={() => {
                            setSelectedCohorts(
                              toRecipients(prePopulatedCohorts, formattedCohorts)
                            );
                            setVisibleCoh(false);
                          }}
                          breakpoints={{ "960px": "75vw", "640px": "90vw" }}
                        >
                          <CohortList
                            cohorts={formattedCohorts}
                            totalCount={totalCountAud}
                            query={queryAud}
                            setQuery={setQueryAud}
                            fetchCohorts={fetchCohorts}
                            selectedCohorts={selectedCohorts} // ✅ pass selected users
                            setSelectedCohorts={setSelectedCohorts} // ✅ pass setter
                            onSave={(selectedCohorts) => {
                              handleSaveTab4(selectedCohorts);
                              setPrePopulatedCohorts(
                                selectedCohorts.map((u) => u.id)
                              );
                              setVisibleCoh(false);
                            }}
                            onCancel={() => {
                              setSelectedCohorts(
                                toRecipients(prePopulatedCohorts, formattedCohorts)
                              );
                              setVisibleCoh(false);
                            }}
                            preSelectedIds={prePopulatedCohorts || []}
                          />
                        </Dialog>
                      )}
                      <style>{`
        .p-checkbox .p-checkbox-box {
          width: 16px;
          height: 16px;
          border: 2px solid black;
          border-radius: 2px;
        }
        .p-checkbox .p-checkbox-box.p-highlight {
          background-color: black;
          border-color: black;
        }
        .p-checkbox .p-checkbox-box.p-highlight::after {
          border-color: white;
          border-width: 2px;
        }
      `}</style>
                    </div>
                  )}

                  {activeTab === 3 && (
                    <div className="p-4">
                      <div className="flex flex-column gap-3">
                        {channelList.map((item) => {
                          // Determine if this checkbox should be always checked in edit mode
                          const isAlwaysChecked =
                            item.key === "email" ||
                            item.key === "NotificationWidgets";

                          return (
                            <div
                              key={item.key}
                              className={`flex items-center border p-3 rounded bg-gray-100 relative ${
                                item.comingSoon ? "opacity-60" : ""
                              }`}
                            >
                              <div className="flex items-center">
                                <Checkbox
                                  inputId={item.key}
                                  // Force checked for Email/Notification in edit
                                  checked={
                                    isAlwaysChecked ? true : channels[item.key]
                                  }
                                  onChange={() => {
                                    // Only toggle if not always checked and not coming soon
                                    if (!isAlwaysChecked && !item.comingSoon) {
                                      setChannels((prev) => ({
                                        ...prev,
                                        [item.key]: !prev[item.key],
                                      }));
                                    }
                                  }}
                                  disabled={isAlwaysChecked || item.comingSoon} // disable Email/Notification in edit
                                />
                                <label htmlFor={item.key} className="ml-2">
                                  {item.label}
                                </label>
                              </div>

                              {item.comingSoon && (
                                <span
                                  className="absolute right-4 text-sm text-gray-500 italic"
                                  style={{ marginLeft: "800px" }}
                                >
                                  Coming Soon
                                </span>
                              )}

                              <style>{`
              .p-checkbox .p-checkbox-box {
                width: 16px;
                height: 16px;
                border: 2px solid black;
                border-radius: 2px;
              }
              .p-checkbox .p-checkbox-box.p-highlight {
                background-color: black;
                border-color: black;
              }
              .p-checkbox .p-checkbox-box.p-highlight::after {
                border-color: white;
                border-width: 2px;
              }
            `}</style>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}

                  {isEditable && (
                    <div className="flex justify-content-end mt-4 gap-2">
                      <Button
                        label="Cancel"
                        className="p-button-outlined mr-2" // outlined adds border
                        onClick={() => {
                          RevertToOriginalValues();
                          setIsEditable(false);
                          // Reset any changes or close the form/dialog
                        }}
                      />
                      <Button type="submit" label="Update Content" />
                    </div>
                  )}
                </form>
              );
            }}
          />
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  GetNotificationClone: (params) => dispatch(GetNotificationClone(params)),
  updateNotiBasicInfo: (params) => dispatch(updateNotiBasicInfo(params)),
  getRolesRequest: (params) => dispatch(getRolesRequest(params)),
  listRequest: (params) => dispatch(listRequest(params)),
  GetOthersCategoryRequest: (params) =>
    dispatch(GetOthersCategoryRequest(params)),
  audienceListRequest: (params) => dispatch(audienceListRequest(params)),
  updateCustomNotiRecipant: (params) =>
    dispatch(updateCustomNotiRecipant(params)),
  GetContentRequest: (params) => dispatch(GetContentRequest(params)),
  updateNotificationContentRequest: (params) =>
    dispatch(updateNotificationContentRequest(params)),
  integrationSubtypesRequest: (params) =>
    dispatch(integrationSubtypesRequest(params)),
});

const mapStateToProps = (state) => ({
  response: state.notifications?.details,
  newUpadtedNotificationContent: state.notifications?.updatedBasicInfo,
  categoryData: state.notifications?.categories,
  updatedRecipant: state.notifications?.UpdatedRecipantInfo,
  content: state.notifications?.record,
  integrations: state.integrations?.integrations,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomNotificationForm);
